const countries = [
  "Brasil",
  "Outros",
];

export default countries;
